import '../../assets/index22.css';var T = Object.defineProperty, j = Object.defineProperties;
var q = Object.getOwnPropertyDescriptors;
var a = Object.getOwnPropertySymbols;
var d = Object.prototype.hasOwnProperty, u = Object.prototype.propertyIsEnumerable;
var f = (o, i, t) => i in o ? T(o, i, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[i] = t, s = (o, i) => {
  for (var t in i || (i = {}))
    d.call(i, t) && f(o, t, i[t]);
  if (a)
    for (var t of a(i))
      u.call(i, t) && f(o, t, i[t]);
  return o;
}, p = (o, i) => j(o, q(i));
var N = (o, i) => {
  var t = {};
  for (var c in o)
    d.call(o, c) && i.indexOf(c) < 0 && (t[c] = o[c]);
  if (o != null && a)
    for (var c of a(o))
      i.indexOf(c) < 0 && u.call(o, c) && (t[c] = o[c]);
  return t;
};
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import D from "react";
import { c as E } from "../../factory-ueRxoNOV.js";
import { XMarkFarFAIcon as G, CircleExclamationFarFAIcon as H, TriangleExclamationFarFAIcon as Q, CheckCircleFarFAIcon as R } from "../Icons/index.js";
import { Button as g } from "../Button/index.js";
import { ProgressIndicator as U } from "../ProgressIndicator/index.js";
import { G as M } from "../../Group-CbE78j-X.js";
import { T as O } from "../../Transition-esp-rpzm.js";
const P = "Notification-module__notification___nI0iq", V = "Notification-module__icon___b9vhU", W = "Notification-module__message___-NZHQ", X = "Notification-module__content___iQDHV", Y = "Notification-module__closeButton___I6Wcx", Z = "Notification-module__notificationActionBtn___Yiatt", J = "Notification-module__actions___zUDpN", K = "Notification-module__notificationsStack___iq4Sf", $ = "Notification-module__notificationsContainer___aNOuN", L = "Notification-module__slideIn___9yi-A", e = {
  notification: P,
  icon: V,
  message: W,
  content: X,
  closeButton: Y,
  notificationActionBtn: Z,
  actions: J,
  notificationsStack: K,
  notificationsContainer: $,
  slideIn: L
}, oo = D.forwardRef((io, F) => {
  var _ = io, {
    message: o,
    variant: i,
    withCloseButton: t = !0,
    onClose: c,
    className: h,
    visible: v = !0,
    actionLabel: l,
    onAction: m,
    transition: I = "slide-left",
    transitionDuration: x = 200,
    transitionTimingFunction: C = "ease",
    position: z = "bottom-right"
  } = _, B = N(_, [
    "message",
    "variant",
    "withCloseButton",
    "onClose",
    "className",
    "visible",
    "actionLabel",
    "onAction",
    "transition",
    "transitionDuration",
    "transitionTimingFunction",
    "position"
  ]);
  const y = {
    success: {
      icon: /* @__PURE__ */ n(R, { size: 16, filled: !0 }),
      color: "var(--plum-green-5)"
    },
    warning: {
      icon: /* @__PURE__ */ n(Q, { size: 16, filled: !0 }),
      color: "var(--plum-orange-5)"
    },
    error: {
      icon: /* @__PURE__ */ n(H, { size: 16, filled: !0 }),
      color: "var(--plum-red-5)"
    },
    loading: {
      icon: /* @__PURE__ */ n(U, { size: 16, color: "violet" }),
      color: "var(--plum-violet-5)"
    }
  }, { icon: A, color: k } = y[i], b = {
    "top-right": { top: 32, right: 32 },
    "top-left": { top: 32, left: 32 },
    "bottom-right": { bottom: 32, right: 32 },
    "bottom-left": { bottom: 32, left: 32 }
  }, S = /* @__PURE__ */ r(
    "div",
    p(s({
      className: E(e.notification, e[i], h),
      ref: F,
      role: "alert"
    }, B), {
      children: [
        /* @__PURE__ */ n("div", { className: e.content, children: /* @__PURE__ */ r(M, { gap: "xs", align: "center", wrap: "nowrap", children: [
          /* @__PURE__ */ n("div", { className: e.icon, style: { color: k }, children: A }),
          /* @__PURE__ */ n("div", { className: e.message, children: o })
        ] }) }),
        /* @__PURE__ */ r("div", { className: e.actions, children: [
          l && m && /* @__PURE__ */ n(
            g,
            {
              variant: "tertiary",
              size: "sm",
              onClick: m,
              className: e.notificationActionBtn,
              children: l
            }
          ),
          t && /* @__PURE__ */ n(
            g,
            {
              variant: "tertiary",
              size: "sm",
              onClick: c,
              "aria-label": "Close notification",
              className: e.closeButton,
              leftSection: /* @__PURE__ */ n(G, { size: 16 })
            }
          )
        ] })
      ]
    })
  );
  return /* @__PURE__ */ n("div", { style: s({ position: "fixed", zIndex: 999 }, b[z]), children: /* @__PURE__ */ n(
    O,
    {
      mounted: v,
      transition: I,
      duration: x,
      timingFunction: C,
      children: (w) => /* @__PURE__ */ n("div", { style: w, children: S })
    }
  ) });
});
oo.displayName = "Notification";
export {
  oo as Notification
};
